import { ActionContext } from 'vuex'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure } from '@/store'
import { IUiState } from './state'
import { AlsUser } from '@/models/als/AlsUser'
import { AlsProduit } from '@/models/als/AlsProduit'
import { AlsTiers } from '@/models/als/AlsTiers'

export class UiAction {       
    public [types.UI_CLOSE_SNACKBAR](context: ActionContext<IUiState, IRootState>) {
        return new Promise((resolve) => {
            context.commit(types.UI_CLOSE_SNACKBAR)
            resolve()
        })
    }
    public [types.UI_ADD_SNACK_MESSAGE](context: ActionContext<IUiState, IRootState>,message:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_ADD_SNACK_MESSAGE  ,message)
            resolve()
        })
    }

    public [types.UI_SET_CONTENT_HEIGHT](context: ActionContext<IUiState, IRootState>,height:number) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_CONTENT_HEIGHT,height)
            resolve()
        })
    }    

    public [types.UI_SET_RIGHT_DRAWER_OPEN](context: ActionContext<IUiState, IRootState>,open:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_RIGHT_DRAWER_OPEN,open)
            resolve()
        })
    }    

    public [types.UI_SET_RIGHT_DRAWER_ENABLE](context: ActionContext<IUiState, IRootState>,enable:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_RIGHT_DRAWER_ENABLE,enable)
            resolve()
        })
    }    

    public [types.UI_SET_ALLERGENE_VISIBLITY](context: ActionContext<IUiState, IRootState>,visibility:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_ALLERGENE_VISIBLITY,visibility)
            resolve()
        })
    } 
    
    public [types.UI_SET_CART_VISIBLITY](context: ActionContext<IUiState, IRootState>,visibility:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_CART_VISIBLITY,visibility)
            resolve()
        })
    }  

    public [types.UI_SET_PRINT_MODE](context: ActionContext<IUiState, IRootState>,enable:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_PRINT_MODE,enable)
            resolve()
        })
    } 


    //////////////////////////////////////////////////////////////////
    // SEJOUR
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_SEJOUR](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_SEJOUR  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_SEJOUR_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_SEJOUR_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_SEJOUR_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_SEJOUR_BY  ,sort)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // USER 
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_USER](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_USER  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_USER_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_USER_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_USER_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_USER_BY  ,sort)
            resolve()
        })
    }


    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_COMMANDE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_COMMANDE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COMMANDE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COMMANDE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_COMMANDE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_COMMANDE_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_MAIL_TEMPLATE](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_MAIL_TEMPLATE  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_TEMPLATE_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_TEMPLATE_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_TEMPLATE_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_TEMPLATE_BY  ,sort)
            resolve()
        })
    }

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    public [types.UI_SET_SEARCH_MAIL_SKIN](context: ActionContext<IUiState, IRootState>,search:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SEARCH_MAIL_SKIN  ,search)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_SKIN_DESC](context: ActionContext<IUiState, IRootState>,desc:boolean) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_SKIN_DESC  ,desc)
            resolve()
        })
    }
    public [types.UI_SET_SORT_MAIL_SKIN_BY](context: ActionContext<IUiState, IRootState>,sort:string) {
        return new Promise((resolve) => {
            context.commit(types.UI_SET_SORT_MAIL_SKIN_BY  ,sort)
            resolve()
        })
    }

    
    
}

export default util.classToObject(UiAction)
